import {
  DomainExplorerContent,
  CatalogKindExploreContent,
  ExploreLayout,
} from '@backstage-community/plugin-explore';

export const ExplorePage = () => {
  return (
    <ExploreLayout title="Explore" subtitle="Browse our ecosystem">
      <ExploreLayout.Route path="domains" title="Domains">
        <DomainExplorerContent title="Domain" />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="systems" title="Systems">
        <CatalogKindExploreContent kind="system" />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="groups" title="Groups">
        <CatalogKindExploreContent kind="group" />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="users" title="Users">
        <CatalogKindExploreContent kind="user" />
      </ExploreLayout.Route>
    </ExploreLayout>
  );
};

export const explorePage = <ExplorePage />;
